export default __webpack_public_path__ + "static/media/Andarr.8e6eae23.svg";